// src/pages/Download.js
import React from 'react';
import './General.css';
import './Download.css';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga4';

const Download = () => {
  // Parameterized download handler for both platforms
  const handleDownloadClick = (platform) => {
    ReactGA.event({
      category: 'Downloads', // Logical category for the event
      action: 'Download Button Click', // Action performed
      label: `Download for ${platform}`, // Label depends on the platform
    });
  };

  return (
    <div className='general-content'>
      <Helmet>
        <title>Download FaceLead</title>
        <meta name="description" content="FaceLead is free to download" />
      </Helmet>
      <h1>Download FaceLead</h1>

      <div className="download-buttons"> 
        <a
          href="https://github.com/Adricarpin/facelead_releases/releases/download/1.1.0/FaceLead.Setup.1.1.0.exe"
          download
          onClick={() => handleDownloadClick('Windows')}
        >
          <button className="learn-more-btn">Download for Windows</button>
        </a>
        <a
          href="https://github.com/Adricarpin/facelead_releases/releases/download/1.1.0/FaceLead-1.1.0-arm64-mac.zip"
          download
          onClick={() => handleDownloadClick('MacOS')}
        >
          <button className="learn-more-btn">Download for Apple Silicon</button>
        </a>

      </div>
      <p className='license-p'>
        By downloading and using FaceLead, you agree to the <a href="/legal" className="license-link">license terms</a>
      </p>
    </div>
  );
};

export default Download;
